import { supabase } from '@/lib/supabase';

// ─────────────────────────────────────────────────────────────
// ZIFEK — Réglages d'une marketplace (dashboard propriétaire).
//
// Le commerce de type marketplace décide notamment si les vendeurs
// qui s'inscrivent sont approuvés automatiquement ou doivent attendre
// la validation du propriétaire.
// ─────────────────────────────────────────────────────────────

export interface MarketplaceSettings {
  /** Les nouveaux vendeurs sont-ils approuvés sans validation manuelle ? */
  autoApproveVendors: boolean;
}

const DEFAULTS: MarketplaceSettings = {
  autoApproveVendors: false,
};

/** Réglages d'une marketplace (valeurs par défaut si aucune ligne). */
export async function fetchMarketplaceSettings(commerceId: number): Promise<MarketplaceSettings> {
  if (!Number.isFinite(commerceId) || commerceId <= 0) return { ...DEFAULTS };
  try {
    const { data, error } = await supabase
      .from('marketplace_settings')
      .select('auto_approve_vendors')
      .eq('idcommerce', commerceId)
      .maybeSingle();
    if (error || !data) return { ...DEFAULTS };
    return {
      autoApproveVendors: Boolean((data as { auto_approve_vendors?: boolean }).auto_approve_vendors),
    };
  } catch {
    return { ...DEFAULTS };
  }
}

/** Active/désactive l'approbation automatique des vendeurs d'une marketplace. */
export async function setMarketplaceAutoApprove(commerceId: number, value: boolean): Promise<void> {
  if (!Number.isFinite(commerceId) || commerceId <= 0) return;
  const { error } = await supabase
    .from('marketplace_settings')
    .upsert(
      {
        idcommerce: commerceId,
        auto_approve_vendors: value,
        updated_at: new Date().toISOString(),
      },
      { onConflict: 'idcommerce' },
    );
  if (error) throw error;
}